import { TOtpStore } from '~/store/otp-verification/types.ts';

export const otpVerificationState: TOtpStore = {
  phone: '',
  valid: false,
  otp: '',
  isVerified: false,

  loading: false,
  error: null,
  status: '',
};
